<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="dedication">
<h1>Dedication</h1>
<p>This book is dedicated to my grandchildren—Rhys, Maddison, Nadim, Adia, Harrison, and Tuscany—whose efforts to raise the Earth’s vibration I look forward to witnessing, either during this life or the life to come.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?19ac5d5a